var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import { GeminiUsageLevelEnum } from '@workalizer/shared/enums';
import { calculateAverage } from '@workalizer/shared/utils';
export var GEMINI_USAGE_LEVELS = [
    GeminiUsageLevelEnum.ZERO,
    GeminiUsageLevelEnum.LOW,
    GeminiUsageLevelEnum.MEDIUM,
    GeminiUsageLevelEnum.HIGH
];
export var GEMINI_USAGE_LEVEL_RANK = (_a = {},
    _a[GeminiUsageLevelEnum.ZERO] = 0,
    _a[GeminiUsageLevelEnum.LOW] = 1,
    _a[GeminiUsageLevelEnum.MEDIUM] = 2,
    _a[GeminiUsageLevelEnum.HIGH] = 3,
    _a);
export var emptyGeminiUsageLevelCounts = function () {
    var _a;
    return (_a = {},
        _a[GeminiUsageLevelEnum.ZERO] = 0,
        _a[GeminiUsageLevelEnum.LOW] = 0,
        _a[GeminiUsageLevelEnum.MEDIUM] = 0,
        _a[GeminiUsageLevelEnum.HIGH] = 0,
        _a);
};
export var countGeminiUsageLevels = function (levels) {
    var counts = emptyGeminiUsageLevelCounts();
    for (var _i = 0, levels_1 = levels; _i < levels_1.length; _i++) {
        var level = levels_1[_i];
        counts[level] += 1;
    }
    return counts;
};
/** When several levels tie, prefer the higher engagement tier. */
export var resolveModeGeminiUsageLevel = function (counts) {
    var mode = GeminiUsageLevelEnum.ZERO;
    var maxCount = -1;
    for (var _i = 0, _a = __spreadArray([], GEMINI_USAGE_LEVELS, true).reverse(); _i < _a.length; _i++) {
        var level = _a[_i];
        if (counts[level] > maxCount) {
            maxCount = counts[level];
            mode = level;
        }
    }
    return mode;
};
export var resolveAverageGeminiUsageLevel = function (levels) {
    if (levels.length === 0) {
        return GeminiUsageLevelEnum.ZERO;
    }
    var totalRank = levels.reduce(function (sum, level) { return sum + GEMINI_USAGE_LEVEL_RANK[level]; }, 0);
    var avgRank = Math.round(calculateAverage(totalRank, levels.length));
    var clampedRank = Math.min(Math.max(avgRank, 0), GEMINI_USAGE_LEVELS.length - 1);
    return GEMINI_USAGE_LEVELS[clampedRank];
};
export var resolveAverageGeminiUsageLevelFromCounts = function (counts) {
    var teamSize = GEMINI_USAGE_LEVELS.reduce(function (sum, level) { return sum + counts[level]; }, 0);
    if (teamSize === 0) {
        return null;
    }
    var totalRank = GEMINI_USAGE_LEVELS.reduce(function (sum, level) { return sum + GEMINI_USAGE_LEVEL_RANK[level] * counts[level]; }, 0);
    var avgRank = Math.round(calculateAverage(totalRank, teamSize));
    var clampedRank = Math.min(Math.max(avgRank, 0), GEMINI_USAGE_LEVELS.length - 1);
    return GEMINI_USAGE_LEVELS[clampedRank];
};
